export default {
  ADD_QUERY(state, query) {
    state.queries.push(query);
  },
  CLEAR_QUERIES(state) {
    state.queries = [];
  },
};
